$(document).ready(function() {
  // REDIRECTION FOR DATA-URL //
  $('[data-url]').click(function() {
    var post_url = $(this).data('url');
    if(post_url) {
      window.location.href = post_url;
    }
  });

  // ACCORDEONS //
  accordeonItems = $("  .up-prog--plus__logement,   .up-prog--plus__residence");

  accordeonItems.children("ul").addClass("accordeonClosed");
  accordeonItems.children("p").click(function(){
    $(this).parent().children("ul").toggleClass("accordeonClosed");
  });

  // Page 404 //
  // var windowHeight = $( window ).height();
  // var headerHeight = $("header").height() + $("footer").height();
  // var footerHeight = $("footer").height();
  var heightContent = $( window ).height() - $("header").height() - $("footer").height() - 108;
  // console.log(heightContent);
  $(".up-404").css('min-height', heightContent);
  $( window ).resize( function() {
    heightContent = $( window ).height() - $("header").height() - $("footer").height() - 108;
    // console.log(heightContent);
    $(".up-404").css('min-height', heightContent);
  });


}); //end document ready function
